<template>
  <div class="fu-step">
    <h1 class="fu-step-title">{{ title }}</h1>

    <div class="fu-form-group">
      <div class="fu-info-text">
        {{ message }}
      </div>
    </div>

    <button class="fu-btn-primary" @click="$emit('go-to-login')" t_label="btn_emp2_BackToLogin_ForgotUsernameSuccess">
      {{ $t('lbl_emp2_BackToLogin') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ForgotUsernameSuccess',
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['email', 'mobile'].includes(value);
      }
    }
  },
  computed: {
    title() {
      return this.type === 'mobile' ? this.$t('lbl_emp2_CheckYourSMS') : this.$t('lbl_emp2_CheckYourMailbox');
    },
    message() {
      return this.type === 'mobile'
        ? this.$t('lbl_emp2_UsernameSentToMobile')
        : this.$t('lbl_emp2_UsernameSentToEmail');
    }
  }
};
</script>

<style scoped>
.fu-step {
  gap: 24px !important;
  margin: -40px -24px !important;
  padding: 40px 24px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  width: calc(100% + 48px) !important;
  align-self: stretch !important;
}

.fu-step-title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 28px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 36.40px;
  margin: 0;
  word-wrap: break-word;
}

.fu-form-group {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  gap: 16px;
}

.fu-info-text {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
  text-align: left;
}
</style>

